import { apiClient } from '@applyonline/shared'
import {
  BaseComputeAmountForFrequencyDto,
  ComputedAmountForFrequency,
  MonthlyPayment,
} from '@applyonline/shared/types'
import { QueryFunctionContext, useQuery } from '@tanstack/react-query'
const AMOUNT_FOR_FREQUENCY = 'amountForFrequency'

export interface ComputeAmountForFrequencyDto extends BaseComputeAmountForFrequencyDto {
  merchantId: string
  paymentPlanId: string
}

const keysFactory = {
  amountForFrequency: (computeParams: ComputeAmountForFrequencyDto | null) =>
    [{ scope: AMOUNT_FOR_FREQUENCY }, computeParams] as const,
}

const computePaymentAmountForFrequency = async ({
  queryKey: [_, computeParams],
}: QueryFunctionContext<ReturnType<(typeof keysFactory)['amountForFrequency']>>) => {
  const response = await apiClient.post('b2c/CreditApplication/computeAmountForFrequency', computeParams)
  return response.data as ComputedAmountForFrequency
}

export function useComputePaymentAmountForFrequency(
  computeParams: ComputeAmountForFrequencyDto | null,
): [ComputedAmountForFrequency | null, boolean] {
  const { isFetching, data } = useQuery({
    queryKey: [...keysFactory.amountForFrequency(computeParams)],
    queryFn: computePaymentAmountForFrequency,
    enabled: computeParams !== null,
  })

  return [data ?? null, isFetching]
}
export type {
  BaseComputeAmountForFrequencyDto,
  ComputedAmountForFrequency,
  MonthlyPayment
}
